import api from '..'
import { DashboardResponse } from './type'
import { logger } from '../../utils/logger'

export const getCustomerDashboardStatsFn = async () => {
  try {
    const response = await api.get<DashboardResponse>('auth/customer/dashboard')
    return response.data
  } catch (error) {
    logger.logError(error instanceof Error ? error : new Error('Get dashboard stats error'), {
      type: 'get_dashboard_stats_error'
    })
    throw error
  }
}
